import { connect } from 'react-redux';
import { fetchAllGuidesIfNeeded } from 'help/ducks/guides';
import AllGuides from 'help/components/all_guides';
import { bindActionCreators } from 'redux';

AllGuides.need = [fetchAllGuidesIfNeeded];

export function mapStateToProps({ help: { guides } }) {
  return {
    ...guides
  };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchAllGuidesIfNeeded
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AllGuides);



// WEBPACK FOOTER //
// ./help/containers/all_guides.js